import { useContext } from 'react';
import { Context } from '../../../components/root/context';

const TopBanner = ({ className }: { className?: string }) => {
  const { bannerNotifications } = useContext(Context);

  if (!bannerNotifications || bannerNotifications.length === 0) {
    return null;
  }

  return (
    <div className={`z-1 w-full flex flex-col gap-2 justify-center text-center ${className}`}>
      {bannerNotifications.map((n, idx) => (
        <div key={`${n.message}-${idx}`} className="py-2 border rounded-2xl bg-opacity-5 bg-blue-500 border-blue-500 text-blue-500">
          <span>{n.message}</span>
        </div>
      ))}
    </div>
  );
};

export default TopBanner;
